module.exports = __webpack_public_path__ + "static/media/gibson.29c69558.png";